import { render, staticRenderFns } from "./FeedbackTwo.vue?vue&type=template&id=7c7e0021&"
import script from "./FeedbackTwo.vue?vue&type=script&lang=js&"
export * from "./FeedbackTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports